import { ReactNode } from 'react';
import { XMarkIcon, CheckCircleIcon, ExclamationTriangleIcon, InformationCircleIcon } from '@heroicons/react/24/outline';
import '@/styles/alert.css';
import { useTranslation } from 'react-i18next';

interface AlertProps {
  type?: 'success' | 'error' | 'warning' | 'info';
  title?: string;
  message: string;
  onClose?: () => void;
  children?: ReactNode;
  className?: string;
}

export const Alert = ({ 
  type = 'info', 
  title, 
  message, 
  onClose, 
  children,
  className = '' 
}: AlertProps) => {
  const { t } = useTranslation();
  const icons = {
    success: CheckCircleIcon,
    error: XMarkIcon,
    warning: ExclamationTriangleIcon,
    info: InformationCircleIcon,
  };

  const Icon = icons[type];

  return (
    <div className={`alert alert-${type} ${className}`} role="alert">
      <Icon className="alert-icon" aria-hidden="true" />
      <div className="alert-content">
        {title && <div className="alert-title">{title}</div>}
        <div className="alert-message">{message}</div>
        {children}
      </div>
      {onClose && (
        <button
          className="alert-close"
          onClick={onClose}
          aria-label={t('alert.close')}
          type="button"
        >
          <XMarkIcon className="alert-close-icon" />
        </button>
      )}
    </div>
  );
};

